"use client"

import { Input } from "@/shared/components/ui/input"
import { Search } from "lucide-react"
import { useRouter, useSearchParams } from "next/navigation"
import { useState, useEffect } from "react"
import { useDebouncedCallback } from "use-debounce"

function VolunteerSearchInput() {
    const router = useRouter()
    const searchParams = useSearchParams()
    const [searchValue, setSearchValue] = useState(
        searchParams.get("search") || ""
    )

    // Sync from URL when search is set by column filter (or elsewhere)
    useEffect(() => {
        setSearchValue(searchParams.get("search") || "")
    }, [searchParams])

    // Debounce search to avoid too many API calls
    const searchInputOnChangeHandler = useDebouncedCallback((value: string) => {
        const params = new URLSearchParams(searchParams.toString())

        if (value && value.trim().length > 0) {
            params.set("search", value)
        } else {
            params.delete("search")
        }

        // Reset to first page when searching
        params.set("page", "1")

        router.push(`?${params.toString()}`)
    }, 750)

    return (
        <Input
            placeholder="Search volunteers"
            leftIcon={<Search className="text-muted-foreground text-sm w-4" />}
            className="h-10 rounded-md pl-9"
            value={searchValue}
            onChange={(e) => {
                const value = (e.target as HTMLInputElement).value
                setSearchValue(value)
                searchInputOnChangeHandler(value)
            }}
        />
    )
}

export default VolunteerSearchInput